import ImageSliders from "../../components/common/ImageSlider";
import { useLocation, useNavigate, useParams } from "react-router";
import useQueryParams from "../../hooks/useQueryParams";
import { API_BASE_URL, DEFAULT_PAGE_DESCRIPTION, DEFAULT_PAGE_TITLE } from "../../utilities/constants";
import { useEffect, useState } from "react";
import { handleApiCall, jsonToQueryParams } from "../../utilities/helper";
import PageMeta from "../../components/common/PageMeta";
import PageBreadcrumb from "../../components/common/PageBreadCrumb";
import Spinner from "../../components/ui/Spinner";

const ProductDetails = () => {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState();
  const { id } = useParams();
  const navigate = useNavigate();
  const [controller, setController] = useState(null);
  const { queryParams } = useQueryParams();
  const categorySearch = queryParams.get("searchCategory") || "";
  const searchProduct = queryParams.get("searchProduct") || "";
  const productPage = queryParams.get("page") || 0;
  const sortOrder = queryParams.get("sortOrder") || "DESC";
  const location = useLocation();
  const merchantId = location.state?.merchantId;
  const user = location.state?.catalogData;
  const categoryId = location.state?.categoryId;

  const callListApi = async () => {
    controller?.abort();
    const newController = new AbortController();
    setController(newController);
    const { signal } = newController;
    setLoading(true);
    try {

      const response = await handleApiCall(
        `${API_BASE_URL}/api/1.0.0/products/${id}`,
        {
          method: "GET"
        },
        null,
        signal
      );
      if (response.responseStatus == true) {
        setData(response.data);
      } else {
        setData(null);
      }
      if (response.responseCode !== 299) {
        setLoading(false);
      }
    } catch (e) {
      console.error("Error", e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (id) {
      callListApi();
    }
  }, [id]);
  const Images = [data?.images];

  return (
    <>
      <PageMeta
        title={`Product Details - ${DEFAULT_PAGE_TITLE}`}
        description={`Product Details - ${DEFAULT_PAGE_DESCRIPTION}`}
      />

      <div className="flex justify-between items-center mb-2">
        <PageBreadcrumb pageTitle="Product Details" />

        <button
          onClick={() =>
            navigate(
              `/catalog?${jsonToQueryParams({
                categorySearch,
                searchProduct,
                page: productPage,
                sortOrder,
              })}`,
              { state: { merchantId: merchantId, categoryId: categoryId, user: user } }
            )
          }
          className="px-4 py-2 rounded-lg bg-gray-200 hover:bg-gray-300 
             dark:bg-gray-700 dark:hover:bg-gray-600 
             text-gray-800 dark:text-gray-200 text-sm font-medium transition"
        >
          ← Back
        </button>
      </div>

      {loading ? (
        <div className="flex justify-center items-center">
          <Spinner />
        </div>
      ) : (
        <div className="flex flex-col md:flex-row gap-8">
          <div className="w-full md:w-1/2">
            <ImageSliders images={Images} showArrows={true} />
          </div>

          <div className="w-full md:w-1/2 flex flex-col justify-between">
            <h3 className="text-2xl font-semibold text-gray-900 dark:text-white">
              {data?.title}
            </h3>

            <div className="mt-4 text-gray-600 dark:text-gray-300 space-y-1">
              <p className="text-base">
                <span className="font-medium">Category:</span> {data?.category?.name} - {data?.subCategory}
              </p>
              <p><span className="font-medium">Material:</span> {data?.materials}</p>
              <p><span className="font-medium">Sizes:</span> {data?.sizes}</p>
              <p><span className="font-medium">Color:</span> {data?.colors}</p>
              <p><span className="font-medium">Gender:</span> {data?.gender?.name}</p>
            </div>
            <p className="text-2xl font-bold text-green-600 mt-6">
              {data?.currency} {data?.price}
            </p>
            <hr className="my-6 border-gray-200 dark:border-gray-700" />

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-y-2 text-sm text-gray-700 dark:text-gray-400">
              <p><span className="font-medium">Brand:</span> {data?.brand}</p>
              <p><span className="font-medium">Availability:</span> {data?.availability.replace("_", " ")}</p>
              <p><span className="font-medium">Rating:</span> ⭐ {data?.rating}</p>
              <p><span className="font-medium">Ships To:</span> {data?.countryShipTo}</p>
              <p><span className="font-medium">Partner:</span> {data?.partner?.name}</p>
            </div>
          </div>
        </div>
      )}
    </>
  );
  // return (
  //   // <div className="max-w-6xl mx-auto p-4 md:p-6">
  //   <>
  //     <PageMeta
  //       title={`Product Details - ${DEFAULT_PAGE_TITLE}`}
  //       description={`Product Details - ${DEFAULT_PAGE_DESCRIPTION}`}
  //     />

  //     {/* Header Section */}
  //     <div className="flex justify-between items-center mb-2">
  //       <PageBreadcrumb pageTitle="Product Details" />
  //     </div>
  //     {loading ? (
  //       <div className="flex justify-center items-center">
  //         <Spinner />
  //       </div>

  //     ) : (
  //       <div className="flex flex-col md:flex-row gap-8">
  //         <div className="w-full md:w-1/2">
  //           <ImageSliders images={Images} showArrows={true} />
  //         </div>

  //         {/* Right - Product Info */}
  //         <div className="w-full md:w-1/2 flex flex-col justify-between">
  //           {/* Title */}
  //           <h3 className="text-2xl font-semibold text-gray-900 dark:text-white">
  //             {data?.title}
  //           </h3>

  //           {/* Description */}
  //           <div className="mt-4 text-gray-600 dark:text-gray-300 space-y-1">
  //             <p className="text-base">
  //               <span className="font-medium">Category:</span> {data?.category?.name} - {data?.subCategory}
  //             </p>
  //             <p><span className="font-medium">Material:</span> {data?.materials}</p>
  //             <p><span className="font-medium">Sizes:</span> {data?.sizes}</p>
  //             <p><span className="font-medium">Color:</span> {data?.colors}</p>
  //             <p><span className="font-medium">Gender:</span> {data?.gender?.name}</p>
  //           </div>

  //           {/* Price */}
  //           <p className="text-2xl font-bold text-green-600 mt-6">
  //             {data?.currency} {data?.price}
  //           </p>

  //           {/* Divider */}
  //           <hr className="my-6 border-gray-200 dark:border-gray-700" />

  //           {/* Extra Info */}
  //           <div className="grid grid-cols-1 sm:grid-cols-2 gap-y-2 text-sm text-gray-700 dark:text-gray-400">
  //             <p><span className="font-medium">Brand:</span> {data?.brand}</p>
  //             <p><span className="font-medium">Availability:</span> {data?.availability.replace("_", " ")}</p>
  //             <p><span className="font-medium">Rating:</span> ⭐ {data?.rating}</p>
  //             <p><span className="font-medium">Ships To:</span> {data?.countryShipTo}</p>
  //             <p><span className="font-medium">Partner:</span> {data?.partner?.name}</p>
  //           </div>

  //         </div>
  //       </div>
  //     )}



  //   </>

  // );
};

export default ProductDetails;

